/* SERVAL CLUB custom sections. Plain JS, no libraries. Each part initialises on its own root,
   so sections work when the theme editor re-renders them. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function json(root, sel) { var el = $(sel || 'script[type="application/json"]', root); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  var STAR = '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 1.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6L10 15l-5.4 3 1.2-6L1.3 7.8l6.1-.7z"/></svg>';

  /* ---------- countdowns to real end dates ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms, short) {
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600; var m = Math.floor(s / 60); s -= m * 60;
    return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm' + (short ? '' : ' ' + pad(s) + 's');
  }
  function tick() {
    var now = Date.now();
    $$('[data-sv-cd]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-sv-cd')), left = end - now;
      if (isNaN(end)) return;
      if (left <= 0) { var host = el.closest('[data-sv-cd-host]'); if (host) host.hidden = true; el.textContent = 'ended'; return; }
      el.textContent = fmt(left, el.hasAttribute('data-short'));
    });
    $$('[data-sv-days]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-sv-days')), days = Math.ceil((end - now) / 864e5);
      if (isNaN(end)) return;
      if (days < 1) { var host = el.closest('[data-sv-cd-host]'); if (host) host.hidden = true; return; }
      el.textContent = days > 1 ? days + ' days left' : 'last day';
    });
  }

  /* ---------- 3D wordmark and ball rally ---------- */
  function initPlaque(root) {
    var w = $('.sv-word3d', root); if (!w || w.dataset.ready) return; w.dataset.ready = '1';
    var word = $('.face', w).textContent, LAYERS = 18;
    function mix(a, b, t) { return Math.round(a + (b - a) * t); }
    for (var i = LAYERS; i >= 1; i--) {
      var s = document.createElement('span'); s.className = 'layer'; s.textContent = word; s.setAttribute('aria-hidden', 'true');
      var t = (i - 1) / (LAYERS - 1);
      s.style.setProperty('--i', i);
      s.style.color = 'rgb(' + mix(184, 40, t) + ',' + mix(151, 32, t) + ',' + mix(90, 20, t) + ')';
      w.insertBefore(s, w.firstChild);
    }
    var HY = 40, F = 766, H = 12, Z0 = 30, CX = 500;
    function P(X, t, y) { var z = Z0 + t; return [CX + F * X / z, HY + F * (H - y) / z, z]; }
    var court = $('.sv-court', root), ball = $('.ball', root), shadow = $('.bshadow', root), trail = $('.trail', root), hist = [], shot = null;
    function newShot(fromFar, startX) {
      var land = fromFar ? 8 + Math.random() * 14 : 56 + Math.random() * 14;
      return { a: [startX, fromFar ? 74 : 4], b: [(Math.random() - .5) * 22, land], c: [(Math.random() - .5) * 20, fromFar ? 2 : 76], start: performance.now(), far: fromFar };
    }
    function ballAt(now) {
      if (!shot) shot = newShot(false, 4);
      var T1 = 1150, T2 = 520, e = now - shot.start, X, tt, y, k;
      if (e < T1) { k = e / T1; X = shot.a[0] + (shot.b[0] - shot.a[0]) * k; tt = shot.a[1] + (shot.b[1] - shot.a[1]) * k; y = 3 * (1 - k) + 24 * k * (1 - k); }
      else if (e < T1 + T2) { k = (e - T1) / T2; X = shot.b[0] + (shot.c[0] - shot.b[0]) * k; tt = shot.b[1] + (shot.c[1] - shot.b[1]) * k; y = 3 * k + 5 * k * (1 - k); }
      else { shot = newShot(!shot.far, shot.c[0]); hist = []; return ballAt(now); }
      return [X, tt, Math.max(0, y)];
    }
    function drawBall(now) {
      if (!ball) return;
      var b = ballAt(now), p = P(b[0], b[1], b[2]), g = P(b[0], b[1], 0), r = Math.max(1.6, .45 * F / p[2]);
      ball.setAttribute('cx', p[0].toFixed(1)); ball.setAttribute('cy', p[1].toFixed(1)); ball.setAttribute('r', r.toFixed(2));
      shadow.setAttribute('cx', g[0].toFixed(1)); shadow.setAttribute('cy', g[1].toFixed(1));
      shadow.setAttribute('rx', (r * 1.2).toFixed(2)); shadow.setAttribute('ry', (r * .4).toFixed(2));
      shadow.style.opacity = Math.max(.15, 1 - b[2] / 12).toFixed(2);
      hist.push(p[0].toFixed(1) + ' ' + p[1].toFixed(1)); if (hist.length > 26) hist.shift();
      trail.setAttribute('d', 'M' + hist.join('L'));
    }
    var px = 0, py = 0, inView = false, hasPointer = false, raf = 0, t0 = performance.now();
    function frame(now) {
      raf = 0;
      var r = root.getBoundingClientRect(), vh = window.innerHeight;
      var prog = Math.min(1, Math.max(0, (vh - r.top) / (vh * .75))), stand = (1 - prog) * 50, ry, rx;
      if (hasPointer) { ry = px * 24; rx = stand + py * -14; }
      else { var k = (now - t0) / 1000; ry = Math.sin(k * .6) * 16; rx = stand + 8 + Math.sin(k * .45) * 4; }
      w.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      w.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      w.style.setProperty('--mx', (50 + ry * 2.2).toFixed(1) + '%');
      drawBall(now);
      if (inView) raf = requestAnimationFrame(frame);
    }
    if (RM) { shot = { a: [0, 4], b: [4, 58], c: [0, 76], start: performance.now() - 600, far: false }; drawBall(performance.now()); return; }
    if (court) court.classList.add('pre');
    new IntersectionObserver(function (es) {
      inView = es[0].isIntersecting;
      if (inView) { if (court) court.classList.add('go'); if (!raf) raf = requestAnimationFrame(frame); }
    }).observe(root);
    if (FINE) root.addEventListener('pointermove', function (e) {
      hasPointer = true; px = (e.clientX / window.innerWidth) - .5;
      var r = w.getBoundingClientRect(); py = (e.clientY - (r.top + r.height / 2)) / window.innerHeight;
    });
    root.addEventListener('pointerleave', function () { hasPointer = false; t0 = performance.now(); });
  }

  /* ---------- Shop the Court colorway selector ---------- */
  function initShop(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var cfg = json(root) || { colors: [] }, colors = cfg.colors, cur = Math.min(cfg.start || 0, colors.length - 1);
    var imgs = $$('.sv-frame img', root), sw = $('.sv-swatches', root), odo = $('.sv-odo-col', root), nm = $('.sv-cw-name', root), ln = $('.sv-cw-line', root), bar = $('.sv-colorbar', root), btn = $('[data-shop-link]', root);
    colors.forEach(function (c, i) {
      var li = document.createElement('li'), b = document.createElement('button');
      b.className = 'sv-sw'; b.type = 'button'; b.style.setProperty('--c', c.hex);
      b.setAttribute('aria-label', String(i + 1).padStart(2, '0') + ' ' + c.name);
      b.addEventListener('click', function () { if (i !== cur) show(i, !RM); });
      li.appendChild(b); sw.appendChild(li);
    });
    function setName(text, animate) {
      nm.classList.remove('anim'); nm.innerHTML = '';
      text.split('').forEach(function (ch, k) { var e = document.createElement('i'); e.textContent = ch === ' ' ? ' ' : ch; e.style.setProperty('--k', k); nm.appendChild(e); });
      if (animate) { void nm.offsetWidth; nm.classList.add('anim'); }
    }
    function show(i, animate) {
      imgs.forEach(function (im) { im.classList.remove('is-on', 'is-under'); im.style.animation = ''; });
      if (animate && imgs[cur]) imgs[cur].classList.add('is-under');
      if (imgs[i]) { imgs[i].classList.add('is-on'); if (!animate) imgs[i].style.animation = 'none'; }
      odo.style.transform = 'translateY(' + (-i) + 'em)';
      setName(colors[i].name, animate);
      ln.textContent = colors[i].line || '';
      bar.style.setProperty('--sock', colors[i].hex);
      if (animate) { bar.classList.remove('go'); void bar.offsetWidth; bar.classList.add('go'); }
      if (btn) { btn.textContent = 'Shop ' + colors[i].name; btn.href = cfg.url + (cfg.url.indexOf('?') > -1 ? '&' : '?') + 'color=' + (i + 1); }
      $$('.sv-sw', sw).forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      cur = i;
    }
    if (colors.length) show(cur, false);
  }

  /* ---------- Engineering pinned scroll ---------- */
  function initEng(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var steps = $$('.sv-step', root), imgs = $$('.sv-eng-frame img', root), pins = $$('.sv-pin', root), rail = $('.sv-rail', root), list = $('.sv-steps', root);
    function activate(i) {
      steps.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      imgs.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      pins.forEach(function (s, k) { s.classList.toggle('on', k === i); });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(function (s) { io.observe(s); });
    function railUpdate() {
      if (!rail) return;
      var r = list.getBoundingClientRect(), vh = window.innerHeight;
      rail.style.setProperty('--prog', (Math.min(1, Math.max(0, (vh * .5 - r.top) / r.height)) * 100).toFixed(1) + '%');
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(railUpdate); }, { passive: true });
    railUpdate();
  }

  /* ---------- member card ---------- */
  function initCard(root) {
    var card = $('.sv-card', root), stage = $('.sv-card-stage', root); if (!card || card.dataset.ready) return; card.dataset.ready = '1';
    var flipped = false;
    card.addEventListener('click', function () {
      flipped = !flipped; card.style.setProperty('--flip', flipped ? '180deg' : '0deg');
      card.setAttribute('aria-label', flipped ? 'What the list gets you. Flip back to the front' : 'Club card. Flip to see what the list gets you');
    });
    if (FINE && !RM) {
      stage.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--ty', ((x - .5) * 26).toFixed(2) + 'deg');
        card.style.setProperty('--tx', ((.5 - y) * 18).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (x * 100).toFixed(0) + '%');
        card.style.setProperty('--gy', (y * 100).toFixed(0) + '%');
      });
      stage.addEventListener('pointerleave', function () { ['--tx', '--ty', '--gx', '--gy'].forEach(function (p) { card.style.removeProperty(p); }); });
    }
  }

  /* ---------- cart nudge: reads the real cart, sits above the cart totals ---------- */
  /* Pack pricing must match the automatic discounts (and the product page section settings):
     3+ pairs $24.99 off the order, 4+ pairs $42.99 off the order, 5+ pairs $11 off each pair.
     Shopify applies the single best one. Club (subscription) lines never count toward packs. */
  var OFFER = { d3: 2499, d4: 4299, d5: 1100, low: 'court-low-sock', crew: 'court-crew-sock', grip: 'court-overgrip' };
  var ROOT = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  function emit(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data));
  }
  function m2(c) { return '$' + (c / 100).toFixed(2); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  var unitPrice = {};
  function packTotal(hs) {
    var sub = 0, k = hs.length, off = 0;
    hs.forEach(function (h) { sub += unitPrice[h]; });
    if (k >= 3) off = OFFER.d3;
    if (k >= 4) off = Math.max(off, OFFER.d4);
    if (k >= 5) off = Math.max(off, OFFER.d5 * k);
    return sub - off;
  }
  function more(hs, h, k) { var a = hs.slice(); for (var i = 0; i < k; i++) a.push(h); return a; }
  var gripData = null, loaded = null;
  function getProduct(handle) {
    return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  /* live prices of both heights (so a Low-only cart can still quote the Crew price) and the overgrip */
  function loadOffer() {
    if (!loaded) loaded = Promise.all([getProduct(OFFER.low), getProduct(OFFER.crew), getProduct(OFFER.grip)]).then(function (p) {
      if (p[0]) unitPrice.low = p[0].price; if (p[1]) unitPrice.crew = p[1].price; gripData = p[2];
    });
    return loaded;
  }
  function sized(url) { if (!url) return ''; url = url.replace(/^\/\//, 'https://'); return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function nudgeHTML(cart) {
    var hs = [], club = false, hasGrip = false, lastSock = null;
    cart.items.forEach(function (it) {
      if (it.handle === OFFER.grip) hasGrip = true;
      var h = it.handle === OFFER.low ? 'low' : it.handle === OFFER.crew ? 'crew' : '';
      if (!h) return;
      if (it.selling_plan_allocation) { club = true; return; }
      if (unitPrice[h] == null) unitPrice[h] = it.original_price;
      for (var q = 0; q < it.quantity; q++) hs.push(h);
      if (!lastSock) lastSock = { it: it, h: h };
    });
    var n = hs.length;
    if (!n && !club) return '';
    var html = '';
    if (n) {
      if (unitPrice.low == null) unitPrice.low = unitPrice.crew; if (unitPrice.crew == null) unitPrice.crew = unitPrice.low;
      var last = lastSock.h, msg;
      var at5 = function (h) { return unitPrice[h] - OFFER.d5; };
      var best = m2(at5('low')) + (at5('crew') !== at5('low') ? ' (Crew ' + m2(at5('crew')) + ')' : '');
      if (n < 3) {
        var need = 3 - n;
        msg = 'Add <strong>' + need + ' more pair' + (need > 1 ? 's' : '') + '</strong> for the 3-pair price and free shipping.';
        if (packTotal(more(hs, last, need - 1)) === packTotal(more(hs, last, need))) msg += ' The 3rd pair is free.';
      } else if (n === 3) {
        var now = packTotal(hs), addL = packTotal(more(hs, 'low', 1)) - now, addC = packTotal(more(hs, 'crew', 1)) - now;
        msg = '<strong>3-pair price and free shipping unlocked.</strong> Add a 4th pair for ' + m2(addL) + (addC !== addL ? ' (Crew ' + m2(addC) + ')' : '') + '.';
      } else if (n === 4) msg = '<strong>4th pair added.</strong> From 5 pairs, every pair is ' + best + '.';
      else msg = '<strong>Best price unlocked:</strong> ' + best.replace(/^(\$[\d.]+)/, '$1 a pair') + '.';
      var fourth = unitPrice.low - OFFER.d4 + OFFER.d3;
      html = msg + '<div class="m"><i style="width:' + Math.min(100, n / 5 * 100) + '%"></i></div><div class="k"><span>' + n + ' pair' + (n > 1 ? 's' : '') + '</span><span>3 = pack price + free shipping</span><span>4 = 4th pair ' + m2(fourth) + '</span><span>5 = ' + m2(at5('low')) + ' a pair</span></div>';
    }
    /* one offer at a time: the 4th pair on a one-time 3-pair cart, otherwise the overgrip */
    if (n === 3 && !club) {
      var it = lastSock.it, add = packTotal(more(hs, lastSock.h, 1)) - packTotal(hs), name = it.product_title.replace(/ Sock$/, '') + (it.variant_title ? ' · ' + it.variant_title.replace(/ \([^)]*\)/, '') : '');
      html += '<div class="sv-up"><img src="' + esc(sized(it.image)) + '" alt="" loading="lazy"><span class="t"><b>Add a 4th pair · ' + m2(add) + '</b><small>Another ' + esc(name) + '. Same parcel.</small></span><button type="button" class="sv-up-btn" data-sv-up="fourth" data-id="' + it.variant_id + '" data-price="' + add + '" data-h="' + lastSock.h + '">Add</button></div>';
    } else if (!hasGrip && gripData && gripData.available) {
      var opts = '';
      gripData.variants.forEach(function (v) { if (v.available) opts += '<option value="' + v.id + '">' + esc(v.title) + '</option>'; });
      html += '<div class="sv-up"><img src="' + esc(sized(gripData.featured_image)) + '" alt="" loading="lazy"><span class="t"><b>' + esc(gripData.title) + ' · ' + m2(gripData.price) + '</b><small>Ships separately.</small><select aria-label="Overgrip color" data-sv-grip>' + opts + '</select></span><button type="button" class="sv-up-btn" data-sv-up="grip" data-price="' + gripData.price + '">Add</button></div>';
    }
    return html;
  }
  function addFromNudge(btn) {
    var kind = btn.getAttribute('data-sv-up'), id, data;
    if (kind === 'grip') { var sel = btn.parentNode.querySelector('[data-sv-grip]'); id = sel ? +sel.value : 0; data = { price: +btn.dataset.price / 100, color: sel ? sel.options[sel.selectedIndex].text : '', placement: 'cart' }; }
    else { id = +btn.dataset.id; data = { price: +btn.dataset.price / 100, height: btn.dataset.h, pack_size: 4, purchase_type: 'one_time', placement: 'cart' }; }
    if (!id) return;
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        emit(kind === 'grip' ? 'overgrip_added' : 'fourth_pair_added', data);
        /* Reload so the theme's cart (drawer or page) shows Shopify's real discounted totals. */
        try { if (btn.closest('cart-drawer-component, theme-drawer')) sessionStorage.setItem('sv-open-cart', '1'); } catch (e) {}
        location.reload();
      })
      .catch(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; });
  }
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-sv-up]'); if (b) addFromNudge(b); });
  var nudgeTimer = 0;
  function refreshNudges() {
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(function () {
      var totals = $$('.cart-totals');
      totals.forEach(function (t) {
        if (!(t.previousElementSibling && t.previousElementSibling.tagName === 'SERVAL-NUDGE')) t.parentNode.insertBefore(document.createElement('serval-nudge'), t);
      });
      if (!totals.length) return;
      Promise.all([fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), loadOffer()])
        .then(function (res) {
          var cart = res[0];
          /* The old free-overgrip offer saved a cart attribute; clear it so it never reaches an order. */
          if (cart.attributes && cart.attributes['Free overgrip color']) fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Free overgrip color': '' } }) }).catch(function () {});
          var h = nudgeHTML(cart);
          $$('serval-nudge').forEach(function (el) { if (el.innerHTML !== h) el.innerHTML = h; });
        })
        .catch(function () {});
    }, 200);
  }
  function watchCart() {
    refreshNudges();
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var t = recs[i].target;
        if (t.closest && t.closest('serval-nudge')) continue;
        var added = [].slice.call(recs[i].addedNodes);
        if (added.length && added.every(function (n) { return n.tagName === 'SERVAL-NUDGE'; })) continue;
        if ((t.closest && t.closest('.cart-items-component, cart-drawer-component, .cart-totals')) || added.some(function (n) { return n.querySelector && n.querySelector('.cart-totals'); })) { refreshNudges(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('cart:update', refreshNudges);
  }

  function init(scope) {
    $$('[data-sv-plaque]', scope).forEach(initPlaque);
    $$('[data-sv-shop]', scope).forEach(initShop);
    $$('[data-sv-eng]', scope).forEach(initEng);
    $$('[data-sv-club]', scope).forEach(initCard);
  }
  function reopenCart() {
    var flag = null; try { flag = sessionStorage.getItem('sv-open-cart'); sessionStorage.removeItem('sv-open-cart'); } catch (e) {}
    if (!flag) return;
    var d = document.querySelector('theme-drawer#cart-drawer');
    if (d) customElements.whenDefined('theme-drawer').then(function () { if (d.open) d.open(); });
  }
  function boot() { init(document); tick(); setInterval(tick, 1000); watchCart(); reopenCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); tick(); });
  window.SERVAL = { STAR: STAR };
})();
